import React from 'react'
import { FrownOutlined } from '@ant-design/icons'
import { Page } from '../../components'
import './index.scss'

const NotFound = () => (
  <Page inner>
    <div className="not-found">
      <FrownOutlined />
      <h1>404 Not Found</h1>
    </div>
  </Page>
)

export default NotFound
